import { Map } from 'immutable';
import { GET_LOGO_URL, GET_LOGO_URL_FAILURE, GET_LOGO_URL_SUCCESS } from '../constants/actionTypes';

const init = Map({
    logoUrl: '',
    loadingLogo: true
});

export default function logoReducer(state = init, action) {
    const { payload } = action;

    switch (action.type) {
    case GET_LOGO_URL:
        return state.set('loadingLogo', true);
    case GET_LOGO_URL_SUCCESS:
        return state.set('logoUrl', payload.logo_url).set('loadingLogo', false);
    case GET_LOGO_URL_FAILURE:
        return state.set('loadingLogo', false);
    default:
        return state;
    }
}
